import React from "react";

// Folk-floral horizontal band extracted from the sponsorship deck.
export const BotanicalBand = ({ flip = false, className = "" }) => (
  <img
    src="/brand/divider-band.png"
    alt=""
    aria-hidden="true"
    className={`botanical-band select-none ${className}`}
    style={{ transform: flip ? "scaleY(-1)" : "none" }}
    draggable="false"
  />
);

// Symmetric rising botanical (deck page footer motif).
export const BotanicalRise = ({ className = "", flip = false }) => (
  <img
    src="/brand/botanical-rise.png"
    alt=""
    aria-hidden="true"
    className={`botanical-band select-none ${className}`}
    style={{ transform: flip ? "scaleY(-1)" : "none" }}
    draggable="false"
  />
);
